import Model from '@ember-data/model';
import attr from 'ember-data/attr';
import { DataIndexCampaign, DataIndexSegment } from 'cio/utils/data-index';

export default class EventModel extends Model {
  @attr('number') lastSeen!: number;
  @attr('camel-case', { depthLevel: 1 } as any) segments!: DataIndexSegment[];
  @attr('camel-case') campaigns!: DataIndexCampaign[];
  @attr() sample!: unknown;

  type = 'event' as const;
}

// DO NOT DELETE: this is how TypeScript knows how to look up your models.
declare module 'ember-data/types/registries/model' {
  export default interface ModelRegistry {
    event: EventModel;
  }
}
